import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { INSIGHTS } from "@/constants/insights";

export default function Insights() {
  const featured = INSIGHTS.slice(0, 3);

  return (
    <section id="insights" className="relative py-20 sm:py-28" data-testid="insights-section">
      <div className="yg-divider" />
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8 pt-14 sm:pt-20">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10 sm:mb-14">
          <div className="max-w-[640px]">
            <span className="yg-eyebrow">// Insights</span>
            <h2 className="yg-h2 text-[clamp(30px,4.6vw,52px)] mt-3 text-white">
              Ideas on AI,
              <br />
              <span className="text-[var(--yg-violet-light)]">web &amp; growth.</span>
            </h2>
          </div>
          <p className="text-[14.5px] text-[var(--yg-text-mute)] max-w-[340px]">
            Practical, no-hype playbooks on building and automating a modern business.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 sm:gap-5">
          {featured.map((post, i) => (
            <Link
              key={post.slug}
              to={`/insights/${post.slug}`}
              className="yg-card yg-card-hover p-6 sm:p-7 flex flex-col min-h-[240px] group"
              data-testid={`insight-card-${post.slug}`}
              style={{ animation: `yg-rise 700ms ${i * 90}ms both cubic-bezier(.2,.9,.3,1)` }}
            >
              <div className="flex items-center justify-between">
                <span className="yg-mono text-[10px] tracking-[0.2em] uppercase text-[var(--yg-violet-light)]">{post.category}</span>
                <ArrowUpRight className="w-4 h-4 text-[var(--yg-text-dim)] group-hover:text-[var(--yg-violet-light)] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
              </div>
              <h3 className="mt-4 text-white font-extrabold text-[19px] leading-[1.2] tracking-[-0.015em]">{post.title}</h3>
              <p className="mt-3 text-[13.5px] leading-relaxed text-[var(--yg-text-mute)] flex-1">{post.excerpt}</p>
              <div className="mt-5 pt-4 border-t border-[var(--yg-border)] yg-mono text-[10.5px] tracking-[0.16em] uppercase text-[var(--yg-text-dim)]">
                {post.readTime}
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8">
          <Link to="/insights" className="yg-btn yg-btn-ghost" data-testid="insights-view-all">
            View all insights <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
